var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"text-center":""}},[_c('center',[_c('v-img',{attrs:{"src":require("@/assets/suspendedAccount.png"),"width":this.$vuetify.breakpoint.mdAndUp ? '70%' : '100%'}}),_c('label',{staticStyle:{"font-size":"2rem"}},[_vm._v("Sorry"),_c('br'),_vm._v("Temporarily Out of Service (451)")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }